import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  text?: string
  isDisabled?: boolean
  type?: 'default' | 'small'
  onClick?: () => void
}

export const TariffButton: FC<Props> = ({
  text,
  isDisabled,
  type = 'default',
  onClick,
}) => {
  const { t } = useTranslation()

  const isSmall = type === 'small'

  const onClickHandler = () => {
    if (isDisabled) return

    onClick?.()
  }

  return (
    <div
      onClick={onClickHandler}
      className={clsx(s.container, {
        [s.disabled]: isDisabled,
        [s.smallContainer]: isSmall,
      })}
    >
      <AppIcon
        id={AllIcons.INFO}
        width={isSmall ? 16 : 24}
        height={isSmall ? 16 : 24}
        className={s.icon}
      />
      <p className={clsx(isSmall && s.small)}>
        {text || t('tickets_page.tariff_rules')}
      </p>
    </div>
  )
}
